import { motion } from 'framer-motion';
import { Progress } from './ui/progress';
import { CheckCircle2, ChevronRight, Flame, ListChecks } from 'lucide-react';

/**
 * Home tab DMO card: shows progress + streak.
 * Extracted from HomeTab for single-responsibility.
 */
export const DmoProgressCard = ({ dmoStats, streak, onOpen }) => {
  const remaining = Math.max(0, dmoStats.total - dmoStats.completed);
  const allDone = dmoStats.total > 0 && dmoStats.completed === dmoStats.total;

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.5 }}
    >
      <button
        onClick={onOpen}
        className="w-full bg-gradient-to-r from-emerald-500 to-teal-500 hover:from-emerald-600 hover:to-teal-600 text-white rounded-2xl shadow-lg p-4 text-left transition-all"
        data-testid="dmo-tasks-btn"
      >
        <div className="flex items-center justify-between mb-2">
          <div className="flex items-center gap-2">
            <ListChecks className="w-6 h-6" />
            <span className="font-semibold text-lg">DMO Tasks</span>
          </div>
          <div className="flex items-center gap-2">
            {streak.current_streak > 0 && (
              <div
                className={`flex items-center gap-1 rounded-full px-2.5 py-1 ${
                  streak.completed_today ? 'bg-orange-400/90' : 'bg-white/20'
                }`}
                data-testid="dmo-streak-badge"
                title={`Longest streak: ${streak.longest_streak} day${streak.longest_streak !== 1 ? 's' : ''}`}
              >
                <Flame className="w-4 h-4" />
                <span className="text-sm font-semibold">{streak.current_streak}</span>
              </div>
            )}
            {dmoStats.total > 0 ? (
              <div
                className="flex items-center gap-1.5 bg-white/20 rounded-full px-2.5 py-1"
                data-testid="dmo-progress-stat"
              >
                <CheckCircle2 className="w-4 h-4" />
                <span className="text-sm font-semibold">
                  {dmoStats.completed}/{dmoStats.total}
                </span>
              </div>
            ) : (
              <ChevronRight className="w-5 h-5 opacity-80" />
            )}
          </div>
        </div>

        {dmoStats.total > 0 && (
          <div className="mt-1" data-testid="dmo-progress-bar-wrapper">
            <Progress
              value={(dmoStats.completed / dmoStats.total) * 100}
              className="h-2 bg-white/25 [&>div]:bg-white"
              data-testid="dmo-progress-bar"
            />
            <p className="text-xs text-white/90 mt-1.5" data-testid="dmo-progress-text">
              {allDone
                ? (streak.current_streak > 1
                    ? `All DMO complete — ${streak.current_streak}-day streak on fire!`
                    : 'All DMO tasks complete — amazing work!')
                : `${remaining} task${remaining !== 1 ? 's' : ''} remaining today${streak.current_streak > 0 && !streak.completed_today ? ` • Keep your ${streak.current_streak}-day streak alive!` : ''}`}
            </p>
          </div>
        )}
        {dmoStats.total === 0 && (
          <p className="text-xs text-white/90 mt-1">Tap to set up your Daily Method of Operations</p>
        )}
      </button>
    </motion.div>
  );
};

export default DmoProgressCard;
